<div class="row" style="width:100%; height:45vh;" [style.background-color] = "backgroundColor">

</div>
